var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"title"},[_c('b',[_vm._v(_vm._s(_vm.currentSubject))]),_c('span',[_vm._v(" "+_vm._s(_vm.currentExamSeason))])]),(_vm.disciplineId)?_c('Plan',{attrs:{"planData":_vm.previewData}}):_c('Schedule',{attrs:{"scheduleData":_vm.previewData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }